export default __webpack_public_path__ + "static/media/Ocean.a3116b07.jpg";